import { fontStyles } from 'Theme';
import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle, Text, TextStyle } from 'react-native';

const styles = StyleSheet.create({
    circle: {
        height: 7,
        width: 7,
        borderRadius: 3.5,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'green'
    }
});

interface ThumbProps {
    onPress?: () => void,
    color?: string,
    style?: ViewStyle,
    text?: string,
    textStyle?: TextStyle
}

const Thumb = ({ onPress, color, style, text, textStyle }: ThumbProps) => (
    <TouchableOpacity
        style={{
            ...styles.circle,
            ...style,
            backgroundColor: color
        }}
        onPress={onPress}
    >
        <Text style={{ ...fontStyles.subtitle, ...textStyle }}>
            {text}
        </Text>
    </TouchableOpacity>
);

export default Thumb;